import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDatePicker, FormTextField, FormSelect } from '../../../../lib/components';
import { ProfileForm, ProfileFormProps } from '../shared/profileForm';
import Util from '../../../../misc/util';
import { useStore } from '../../../../hooks/useStore';
type Props = Omit<ProfileFormProps, 'children'>;

export const PositionDataForm: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();

  const [missingFields, setMissingFields] = useState<string[]>();

  useEffect(() => {
    setMissingFields(props.formRef?.current?.values?.missing_fields);
  }, [props.formRef?.current?.values?.missing_fields]);

  return (
    <ProfileForm {...props}>
      <FormTextField
        label={t('employee:POSITION_NAME')}
        placeholder={t('employee:POSITION_NAME')}
        name="position_name"
        missing={missingFields?.includes('position_name')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormTextField
        label={t('employee:PERSONAL_NUMBER')}
        placeholder={t('employee:PERSONAL_NUMBER')}
        name="employee_number"
        missing={missingFields?.includes('employee_number')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormSelect
        name="location"
        label={t('employee:OPERATING_SITE')}
        placeholder={t('employee:OPERATING_SITE')}
        options={
          companyStore.locations?.map((l) => ({
            value: l.id,
            text: l.name
          })) || []
        }
        missing={missingFields?.includes('location')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormSelect
        name="department"
        label={t('employee:DEPARTMENT')}
        placeholder={t('employee:DEPARTMENT')}
        options={
          companyStore.departments?.map((d) => ({
            value: d.id,
            text: d.name
          })) || []
        }
        missing={missingFields?.includes('department')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormSelect
        name="cost_center"
        label={t('employee:COST_CENTER')}
        placeholder={t('employee:COST_CENTER')}
        options={
          companyStore.costCenters?.map((c) => ({
            value: c.id,
            text: c.name
          })) || []
        }
        missing={missingFields?.includes('cost_center')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormDatePicker
        label={t('employee:START_DATE')}
        name="entry_date"
        minDate={Util.getMinDate(100)}
        maxDate={Util.getMaxDate(5)}
        xs={6}
        missing={missingFields?.includes('entry_date')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
      />
      <FormDatePicker
        label={t('employee:EXIT_DATE')}
        name="exit_date"
        minDate={Util.getNextDay()}
        maxDate={Util.getMaxDate(5)}
        missing={missingFields?.includes('exit_date')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormTextField
        type="number"
        label={t('employee:WORKING_HOURS_PER_WEEK')}
        placeholder={t('employee:WORKING_HOURS_PER_WEEK')}
        name="working_hours_per_week"
        inputProps={{
          min: 1,
          step: 0.5,
          max: 48
        }}
        missing={missingFields?.includes('working_hours_per_week')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormTextField
        type="number"
        label={t('employee:WORKING_DAYS_PER_WEEK')}
        placeholder={t('employee:WORKING_DAYS_PER_WEEK')}
        name="working_days_per_week"
        inputProps={{
          min: 1,
          step: 1,
          max: 7
        }}
        missing={missingFields?.includes('working_days_per_week')}
        missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
        xs={6}
      />
      <FormTextField label={t('common:NOTE')} placeholder={t('common:NOTE')} name="note" xs={12} />
    </ProfileForm>
  );
};
